import { create } from "zustand";
import { persist } from "zustand/middleware";

export type VideoClipPipSize = "large" | "medium" | "small";
export type VideoClipPipShape = "round" | "square";
export type VideoClipPipPosition =
  | "bottom-left"
  | "bottom-right"
  | "top-left"
  | "top-right";

interface VideoClipSettingsStore {
  pipPosition: VideoClipPipPosition;
  pipShape: VideoClipPipShape;
  pipSize: VideoClipPipSize;
  selectedCameraId: string | null;
  selectedMicId: string | null;
  setPipPosition: (pipPosition: VideoClipPipPosition) => void;
  setPipShape: (pipShape: VideoClipPipShape) => void;
  setPipSize: (pipSize: VideoClipPipSize) => void;
  setSelectedCameraId: (selectedCameraId: string | null) => void;
  setSelectedMicId: (selectedMicId: string | null) => void;
}

export const useVideoClipSettingsStore = create<VideoClipSettingsStore>()(
  persist(
    set => ({
      pipPosition: "bottom-right",
      pipShape: "round",
      pipSize: "medium",
      selectedCameraId: null,
      selectedMicId: null,
      setPipPosition: pipPosition => set({ pipPosition }),
      setPipShape: pipShape => set({ pipShape }),
      setPipSize: pipSize => set({ pipSize }),
      setSelectedCameraId: selectedCameraId => set({ selectedCameraId }),
      setSelectedMicId: selectedMicId => set({ selectedMicId }),
    }),
    {
      name: "video-clip-settings",
      version: 1,
    },
  ),
);
